import { Box, styled } from '@mui/material';

export const StyledCalendarContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  alignItems: 'center',
}));

export const StyledLoaderContainer = styled(Box)(({ theme }) => ({
  width: '750px',
  position: 'absolute',
  borderRadius: '8px',
  height: '340px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledButtonsContainer = styled(Box)(({ theme }) => ({
  paddingLeft: '62px',
  display: 'flex',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(7),
  flexDirection: 'column',
  gap: theme.spacing(5),
  width: '100%',
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(0),
  },
}));
